import { Icon } from './icon.model';
import { InspectionPoint } from './inspectionPoint.model';
import { Inspection } from './inspection.model';

export class Icons {
  public static commentsOrder = 0;
  public static requiredPartsOrder = 1;
  public static hasPartsOrder = 2;
  public static statesOrder = 3;
  public static discussionOrder = 4;
  public static observationsOrder = 5;
  public static pointOkOrder = 6;

  public static commentsIconName = 'comments';
  public static requiredPartsIconName = 'requiredParts';
  public static hasPartsIconName = 'hasParts';
  public static statesIconName = 'states';
  public static discussionCommentIconName = 'discussionComment';
  public static observationIconName = 'observation';
  public static pointOkIconName = 'pointOk';
  public static importantIcon = 'importantIcon';

  public static importanceIcons = ['settings', 'bolt', 'sms_failed'];

  public static icons = {
    requiredParts: () => new Icon('build', 'disabled', 0, Icons.requiredPartsOrder),
    hasParts: () => new Icon('build', '', 0, Icons.hasPartsOrder),
    discussionComment: () => new Icon('comment', 'comment', 0, Icons.discussionOrder),
    observation: () => new Icon('assignment_late', 'assignment_late', 0, Icons.observationsOrder),
    comments: () => new Icon('comment', 'comment', 0, Icons.commentsOrder),
    states: () => new Icon('warning', 'warning', 0, Icons.statesOrder),
    pointOk: () => new Icon('ok', 'baseline-ok icon-image-preview', 0, Icons.pointOkOrder),
    importantIcon1: () => new Icon(Icons.importanceIcons[0], 'comment', 0, Icons.commentsOrder),
    importantIcon2: () => new Icon(Icons.importanceIcons[1], 'comment', 0, Icons.commentsOrder),
    importantIcon3: () => new Icon(Icons.importanceIcons[2], 'comment', 0, Icons.commentsOrder)
  };

  public static getIconByName(iconName: string): Icon {
    return this.icons[iconName]();
  }

  public static initIcon(point: InspectionPoint, icon: Icon) {
    if (point) {
      const iconName = icon.name;
      const iconClasses = icon.classes;
      if (!point.icons) {
        point.icons = [];
      }
      if (!point.icons.some((i) => i.name === iconName && i.classes === iconClasses)) {
        point.icons.push(icon);
      }

      if (point.folder) {
        if (point.folder.icons.some((i) => i.name === iconName && i.classes === iconClasses)) {
          const icon = point.folder.icons.find((i) => i.name === iconName && i.classes === iconClasses);
          icon.count++;
        } else {
          icon.count = 1;
          point.folder.icons.push(icon);
        }
      }
      if (point.section) {
        if (point.section.icons.some((i) => i.name === iconName && i.classes === iconClasses)) {
          const icon = point.section.icons.find((i) => i.name === iconName && i.classes === iconClasses);
          icon.count++;
        } else {
          icon.count = 1;
          point.section.icons.push(icon);
        }
      }
    }
  }

  public static processIcons(toAdd: boolean, icon: Icon, inspection: Inspection, point: InspectionPoint) {
    const iconName = icon.name;
    const iconClasses = icon.classes;
    if (!point) {
      return;
    }

    if (!point.icons) {
      point.icons = [];
    }

    if (
      (toAdd && !point.icons.some((i) => i.name === iconName && i.classes === iconClasses)) ||
      (!toAdd && point.icons.some((i) => i.name === iconName && i.classes === iconClasses))
    ) {
      if (toAdd) {
        point.icons.push(icon);
      }

      if (!toAdd) {
        point.icons = point.icons.filter((i) => i.name !== iconName || i.classes !== iconClasses);
      }

      if (point.folder) {
        if (point.folder.icons.some((i) => i.name === iconName && i.classes === iconClasses)) {
          if (toAdd) {
            const icon = point.folder.icons.find((i) => i.name === iconName && i.classes === iconClasses);
            toAdd ? icon.count++ : icon.count--;
          } else {
            point.folder.icons = point.folder.icons.filter((i) => i.name !== iconName || i.classes !== iconClasses);
          }
        } else {
          if (toAdd) {
            icon.count = 1;
            point.folder.icons.push(icon);
          } else {
            point.folder.icons = point.folder.icons.filter((i) => i.name !== iconName || i.classes !== iconClasses);
          }
        }
      }

      if (point.section) {
        if (point.section.icons.some((i) => i.name === iconName && i.classes === iconClasses)) {
          if (toAdd) {
            const icon = point.section.icons.find((i) => i.name === iconName && i.classes === iconClasses);
            toAdd ? icon.count++ : icon.count--;
          } else {
            point.section.icons = point.section.icons.filter((i) => i.name !== iconName || i.classes !== iconClasses);
          }
        } else {
          if (toAdd) {
            icon.count = 1;
            point.section.icons.push(icon);
          } else {
            point.section.icons = point.section.icons.filter((i) => i.name !== iconName || i.classes !== iconClasses);
          }
        }
      }
    }
  }
}
